import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdChartsDataContext } from './hooks/useHouseholdChartsDataContext';

export const PeoplePerHouse = () => {
    const { chartData } = useHouseholdChartsDataContext();

    return (
        <SimpleBars
            title={'Quantidade de pessoas no Domicílio'}
            horizontal={true}
            subtitles={
                chartData?.peoplePerHouse?.map((item) => item.description) || []
            }
            values={chartData?.peoplePerHouse?.map((item) => item.total  ||  0) || []}
            className='aligned-container'
        />
    );
};
